/**
 * @generated SignedSource<<db8f57fc8c26158166197c89ce22cf71>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useEventState_stream$data = {
  readonly linkedEvent: {
    readonly finalOccurrence: string | null;
    readonly nextOccurrence: {
      readonly end: string | null;
      readonly start: string | null;
    } | null;
  } | null;
  readonly linkedEventGuid: string | null;
  readonly " $fragmentType": "useEventState_stream";
};
export type useEventState_stream$key = {
  readonly " $data"?: useEventState_stream$data;
  readonly " $fragmentSpreads": FragmentRefs<"useEventState_stream">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useEventState_stream",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "linkedEventGuid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Event",
      "kind": "LinkedField",
      "name": "linkedEvent",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Event",
          "kind": "LinkedField",
          "name": "nextOccurrence",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "start",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "end",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "finalOccurrence",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "NoteStream",
  "abstractKey": null
};

(node as any).hash = "94ccff277e56249c68afd4ee526645d9";

export default node;
